import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  detalizationListStack: {
    alignItems: "center",
    gap: "2px",
    paddingTop: "3px",
    "& div svg": {
      paddingBottom: "4px",
    },

    '& .MuiInputBase-root': {
      fontSize: 14,

      [theme.breakpoints.down(1001)]: {
        fontSize: 12,
      },
    },
  },
  selectComponent: {
    minWidth: 0,
    backgroundColor: "transparent",
    paddingLeft: 0,
    // fontSize: 14,
    [theme.breakpoints.down(1001)]: {
      fontSize: 12,
    },
    "& > div": {
      [theme.breakpoints.down(741)]: {
        padding: "0 24px 0 0"
      }
    },

    "& > .MuiInput-input": {
      paddingRight: "2px",

      "&[aria-expanded=false]": {},
    },
    "&:hover:not(.Mui-disabled, .Mui-error):before": {
      border: "none",
    },
    "&:before": {
      border: "none",
    },
    "&.Mui-focused": {
      color: theme.palette.mainButton.blue,

      "&:after": {
        border: "none",
      },
    },
  },
  menuItem: {
    "&.Mui-selected": {
      backgroundColor: "red",
    },
    "&.hide": {
      display: "none",
    },
    fontSize: 12,
    color: theme.palette.mainButton.dark,
    padding: "8px 10px",
  },
}));

export default useStyles;
